
export default {
    Defaults: {
        MaxUploadFileSizeMB: 25
    },
    Question: {
        AnswerType: {
            ShortAnswer: 'ANSWER_TYPE_SHORT_ANSWER',
            Paragraph: 'ANSWER_TYPE_PARAGRAPH',
            SingleChoice: 'ANSWER_TYPE_SINGLE_CHOICE',
            MultipleChoice: 'ANSWER_TYPE_MULTIPLE_CHOICE',
            MultipleChoiceWithNote: 'ANSWER_TYPE_MULTIPLE_CHOICE_WITH_NOTE',
            Info: 'ANSWER_TYPE_INFO',
            FileUpload: 'ANSWER_TYPE_FILE_UPLOAD',
            Date: 'ANSWER_TYPE_DATE',
            Shopping: 'ANSWER_TYPE_SHOPPING',
            LinearScale: 'ANSWER_TYPE_LINEAR_SCALE',
            Section: 'ANSWER_TYPE_SECTION',
            Address: 'ANSWER_TYPE_ADDRESS',
            Youtube: 'ANSWER_TYPE_YOUTUBE',
            SingleMatrix: 'ANSWER_TYPE_SINGLE_MATRIX',
            MultipleMatrix: 'ANSWER_TYPE_MULTIPLE_MATRIX',
        }
    },
    CustomerNotificationChannels: {
        EMAIL: 'email',
        SMS: 'sms',
        FACEBOOK: 'facebook',
        LINE: 'line',
    },
    CustomerNotificationPreferenceKeys: {
        booking_related: [
            'booking_request',
            'booking_accepted',
            'booking_rejected',
            'booking_canceled',
            'booking_canceled_by_customer',
            'unpaid_booking_order_reminder',
            'booking_reminder',
            // Disabled for now and wait for survey module goes live
            // 'booking_survey_request',
        ],
        payment_related: [
            'payment_request',
            'payment_paid',
            'payment_canceled',
            'payment_expire_reminder',
        ],
        logistic_related: [
            'order_shipped',
        ],
        contract_signing: [
            'contract_signing_request',
            'contract_signed',
        ],
        membership_related: [
            'coupon_sent',
            'member_points_sent',
            // Disabled for now, wait to module goes live
            // 'customer_level_changed',
            // 'customer_level_renewed',
            // 'customer_level_expire_reminder',
        ],
        others: [
            'file_vault_invitation',
        ]
    },
    TagColors: [
        "#f5c51e",
        "#0094fb",
        "#417505",
        "#18b693",
        "#867acc",
        "#2d3033",
        "#8f7156",
        "#c03ea4",
        "#8e8e93",
        "#72a6ca",
        "#cf4740",
        "#7cb524",
        "#4141dc",
        "#b19122",
        "#ff7800",
        "#3eb8c0"
    ],
    BindingPlatform: {
        FACEBOOK: 'facebook',
        LINE: 'line',
    },
    validator: {
        email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
    CustomerLogActions: {
        INCREASE_POINTS: 'INCREASE_POINTS',
        DECREASE_POINTS: 'DECREASE_POINTS',
        VERIFY_SMS: 'VERIFY_SMS',
        VERIFY_SMS_AND_SET_PASSWORD: 'VERIFY_SMS_AND_SET_PASSWORD',
        CREATE_BLOCKED_CUSTOMER: 'CREATE_BLOCKED_CUSTOMER',
        DELETE_BLOCKED_CUSTOMER: 'DELETE_BLOCKED_CUSTOMER',
    },
};
